module.exports = __webpack_public_path__ + "static/media/04-2.0824ab03.webp";